import { Dispatch, FC, SetStateAction } from 'react';
import { ModalActionBlock } from '.';
import { DatasetDetailsForm } from '..';
import { DatasetCreationStepsEnum } from './types';

interface DatasetDetailsStepProps {
  setActiveStep: Dispatch<SetStateAction<DatasetCreationStepsEnum>>;
}

const DatasetDetailsStep: FC<DatasetDetailsStepProps> = ({ setActiveStep }) => (
  <form>
    <DatasetDetailsForm />
    <ModalActionBlock activeStep={DatasetCreationStepsEnum.DETAILS} setActiveStep={setActiveStep} />
  </form>
);

export default DatasetDetailsStep;
